import { useState, useEffect } from "react";
import { Select, Divider, Button } from "antd";
import { EditOutlined, StopOutlined } from "@ant-design/icons";
import { authRequest } from "../../../../common/request/authRequest";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import EditVirtualGroupsModal from "./EditVirtualGroupsModal";

/** Valor especial: fichas sin región asignada */
export const NO_REGION_FILTER = 'NONE';

export default function SelectVirtualGroup({ onChange, defaultValue = null }: any) {
  
  const [groups, setGroups] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState<string>(defaultValue ?? '');
  const [updateData, setUpdateData] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { projectGroup } = useAuth();
       
  useEffect(() => {
    authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/virtual`, {})
      .then((response) => {
        setGroups(response);
      })
      .catch(() => {
        //message.error('Error al cargar grupos virtuales');
      })
      .finally(() => {
        setLoading(false); 
      });
  }, [projectGroup.project, updateData]); 

  return (
    <>
      <Select 
        bordered={false} 
        placeholder="Sin filtrar región"
        optionLabelProp="label"
        onChange={(val) => {
          const next = val ?? '';
          setSelectedId(next);
          onChange(next === '' ? null : next);
        }}
        value={selectedId}
        loading={loading}
        style={{ minWidth: '180px', fontWeight: 500 }}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: '4px 0' }} />
            <Button 
              type="text" 
              block 
              icon={<EditOutlined />} 
              onClick={() => setIsModalOpen(true)}
              style={{ textAlign: 'left', padding: '4px 12px' }}
            >
              Modificar Regiones
            </Button>
          </>
        )}
      >
        <Select.Option value="" label="Sin filtrar región">
          <span style={{ color: '#8c8c8c' }}>Sin filtrar región</span>
        </Select.Option>

        <Select.Option value={NO_REGION_FILTER} label="No hay región">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <StopOutlined />
            <span>No hay región</span>
          </div>
        </Select.Option>
        
        {groups && Object.entries(groups).map(([id, groupData]: [string, any]) => (
          <Select.Option
            key={id}
            value={id}
            label={
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, lineHeight: 1 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: id, flexShrink: 0 }} />
                {groupData}
              </span>
            }
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: id }} />
                {groupData}
              </div>               
            </div>
          </Select.Option>
        ))}
      </Select>
      {isModalOpen && <EditVirtualGroupsModal groups={groups} onChange={() => {setIsModalOpen(false); setUpdateData(!updateData)}}/>}
    </>
  );
}
